
export default {
	install(Vue) {

		/**
		 * 处理老版本浏览器不支持includes
		 */
		Array.prototype.includes = Array.prototype.includes || function (o) {
			return this.indexOf(o) != -1;
		}

		/**
		 * 处理火狐浏览器不支持scrollIntoViewIfNeeded
		 */
		Element.prototype.scrollIntoViewIfNeeded = Element.prototype.scrollIntoViewIfNeeded || function () {
			this.scrollIntoView();
		};

		/**
		 * 处理IE浏览器不支持Promise
		 */
		window.Promise = (function () {
			return window.Promise || function Promise(cb = () => { }) {
				let promises = [];
				this.then = function (resolve, reject) {
					promises.push({ resolve, reject });
					return this;
				}
				this.catch = function (reject) {
					promises.push({ reject });
					return this;
				}
				cb(value => {
					promises.forEach(e => e.resolve && e.resolve(value));
				}, value => {
					promises.forEach(e => e.reject && e.reject(value));
				});
			}
		})();

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/script/compatible.js